import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/learning',
    name: 'learning',
    component: () => import(/* webpackChunkName: "learning" */ '../views/LearningView.vue')
  },
  {
    path: '/course/:id',
    name: 'course',
    component: () => import(/* webpackChunkName: "course" */ '../views/CourseView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
